import { useCallback, useState } from 'react';

import { InsightsJobConfigWithId, InsightsJobFormData } from '../types';
import { convertConfigToFormData } from '../utils/formatUtils';
import { getDefaultFormData } from '../utils/getDefaultFormData';

export function useSelectedConfig({
  updateFormData,
}: {
  updateFormData: (formData: InsightsJobFormData) => void;
}) {
  const [selectedConfigId, setSelectedConfigId] = useState<string | null>(null);

  const setSelectedConfig = useCallback(
    ({
      id,
      configsList,
      skipContentUpdate,
    }: {
      id: string | null;
      configsList: InsightsJobConfigWithId[];
      skipContentUpdate?: boolean;
    }) => {
      if (skipContentUpdate) {
        setSelectedConfigId(id);
        return;
      }

      if (!id) {
        updateFormData(getDefaultFormData());
        setSelectedConfigId(null);
        return;
      }

      const config =
        configsList.find((config) => config.id === id)?.config || {};
      const formData = convertConfigToFormData(config);
      updateFormData(formData);
      setSelectedConfigId(id);
    },
    [updateFormData, setSelectedConfigId]
  );

  return {
    selectedConfigId,
    setSelectedConfig,
  };
}
